import * as React from 'react';

import Grid from '@mui/material/Grid';

import { setGDPRCookie, removeGDPRCookies } from '@app/common/helpers/cookieHelpers';

import './styles.scss';

function Footer() {
  const [isCookiesOptedIn, setIsCookiesOptedIn] = React.useState(
    !document.cookie.includes('gdpr-cookie=false')
  );

  if (!isCookiesOptedIn) {
    removeGDPRCookies();
  }

  const isDeveloperLandingPageOverhaulEnabled =
    window.appConfig.featureFlags.developerLandingPageOverhaul;

  const handleCookiesUpdate = () => {
    let isOptedIn: boolean = !isCookiesOptedIn;

    if (isOptedIn) {
      setGDPRCookie(true);
      // temporary disable non-essential cookie being added on non-sign in page
      // addGDPRCookies();
    } else {
      removeGDPRCookies();
    }

    setIsCookiesOptedIn(isOptedIn);
  };

  return (
    <Grid
      item={true}
      xs={12}
      container={true}
      justifyContent={'center'}
      className={
        isDeveloperLandingPageOverhaulEnabled ? 'background-black' : 'background-dark-grey'
      }
    >
      <Grid item={true} xs={10} lg={8}>
        <div
          className={isDeveloperLandingPageOverhaulEnabled ? 'footer footer__redesign' : 'footer'}
          id="footer-container"
        >
          <div className="footer__copyright-container">
            <div className="footer__copyright-icon">&copy;</div>
            <p data-qa="home-page__footer-copyright">{new Date().getFullYear()} Skillz, Inc</p>
          </div>
          {isCookiesOptedIn ? (
            <div
              id="cookies-opt-out-link"
              className="cookies-opt-out"
              onClick={handleCookiesUpdate}
              data-qa="home-page__footer-cookie-link"
            >
              Cookies opt out
            </div>
          ) : (
            <div
              className="cookies-opt-out"
              id="cookies-opt-in-link"
              onClick={handleCookiesUpdate}
              data-qa="home-page__footer-cookie-link"
            >
              Cookies opt in
            </div>
          )}
        </div>
      </Grid>
    </Grid>
  );
}

export default Footer;
